// extracted by mini-css-extract-plugin
export default {"msgM":"_025aa9bce8"};